import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import ClearIcon from '@material-ui/icons/Clear';
import FavoriteIcon from '@material-ui/icons/Favorite';
import IconButton from '@material-ui/core/IconButton';
import bufficorn from '../img/bufficorn.jpg';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    alignItems: 'center',
    marginBottom: '30%',
  },

  action: {
    display: 'flex',
    justifyContent: 'space-around',
  },
});

export default function MediaCard() {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image="/static/images/cards/contemplative-reptile.jpg"
          title="Contemplative Reptile"
        />
        <CardContent>
          <img src={bufficorn} alt="bufficorn" height="100%" width="100%" />
          <Typography gutterBottom variant="h5" component="h2">
            Bufficorn
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            Hi, I'm Bufficorn and I enjoy hacking and long walks on the beach.
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions className={classes.action}>
        <IconButton>
          <ClearIcon />
        </IconButton>
        <IconButton>
          <FavoriteIcon />
        </IconButton>
      </CardActions>
    </Card>
  );
}
